/**
 * Cognito configuration for admin login.
 *
 * In production: set REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_CLIENT_ID
 * in the Amplify environment variables (or .env.local for local dev).
 *
 * To find the values:
 *   1. Deploy the AuthStack:  cd infra && cdk deploy DevAuthStack
 *   2. Get the outputs:      aws cloudformation describe-stacks --stack-name DevAuthStack --query "Stacks[0].Outputs"
 *   3. Look for 'dev-UserPoolId' and 'dev-WebAdminClientId'
 */

export const COGNITO_CONFIG = {
    region: process.env.REACT_APP_COGNITO_REGION || 'eu-central-1',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || ''
};
